export default "<chart id=\"chart\" class=\"d-flex\" [options]=\"options\" (click)=\"getSelectedValues($event)\"></chart>\n"